

export default amd;
import packageResult from '../../../utils/packageResult';
import amdIntro from '../../../utils/amd/amdIntro';
function amd(bundle, options) {
	var defaultName = bundle.entryModule.identifierReplacements['default'];
	if (defaultName) {
		bundle.body.append('\n\nreturn ' + defaultName + ';');
	}

	var intro = amdIntro({
		name: options.amdName,
		imports: bundle.externalModules,
		indentStr: bundle.body.getIndentString(),
		useStrict: options.useStrict !== false
	});

	bundle.body.indent().prepend(intro).trimLines().append('\n\n});');
	return packageResult(bundle, bundle.body, options, 'toAmd', true);
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/bundler/builders/defaultsMode/amd.js.01-babel.map